import { ApmBase, init as initApm } from '@elastic/apm-rum';
import { attach, createEffect } from 'effector';
import { RootDomain } from 'model/root.model';
import { version } from '../../../package.json';

export const analytics$ = RootDomain.store<ApmBase>(null);
export const transaction$ = RootDomain.store<Transaction>(null);
export const captureErrorFx = attach({
	source: { analytics: analytics$ },
	mapParams: (error: Error, source) => ({ error, analytics: source.analytics }),
	effect: RootDomain.effect<{ error: Error, analytics: ApmBase }, void>({
		handler: (payload) => {
			payload.analytics.captureError(payload.error);
		},
	}),
});
export const initializeAnalyticsFx = RootDomain.effect<{ session: string; tenant: string }, ApmBase>({
	handler: (params) => {
		const analytics = initApm({
			serviceName: 'verify-sdk',
			serverUrl: 'https://f5d6d846677b4101bb9740616f3f5a6e.apm.eu-west-1.aws.cloud.es.io',
			serviceVersion: version,
			breakdownMetrics: true,
			distributedTracingOrigins: ['https://api.hive.id', 'http://localhost:3006'],
			// @ts-ignore
			environment: window.hive_environment || process.env.NODE_ENV || 'production',
		});
		analytics.addLabels({
			session: params.session,
			tenant: params.tenant,
			version: version,
		});

		return analytics;
	},
});
export const handleRouteChangeFx = attach({
	source: { analytics: analytics$, transaction: transaction$ },
	mapParams: (payload: { route: string, from: string }, source) => ({
		...source,
		...payload,
	}),
	effect: createEffect<{ route: string; from: string; transaction: Transaction; analytics: ApmBase }, Transaction>({
		handler: (payload) => {
			if (payload.transaction) {
				payload.transaction.end();
			}

			const transaction = payload.analytics.startTransaction(payload.route, 'route-change');
			transaction.addLabels({
				from: payload.from,
			});
			return transaction;
		},
	}),
});
export const createSpanFx = attach({
	source: { analytics: analytics$ },
	mapParams: (event, source) => ({ event, analytics: source.analytics }),
	effect: RootDomain.effect({
		handler: (payload: { event: any, analytics: ApmBase }) => {
			if (!payload.analytics) { return; }

			const transaction = payload.analytics.startTransaction(payload.event.event, 'events', {
				managed: true,
				canReuse: true,
			});
			transaction.addLabels(payload.event.event_attributes);
			setTimeout(() => {
				transaction.end();
			}, 1000);
		},
	}),
});

transaction$
	.on(handleRouteChangeFx.doneData, (_, result) => result);
analytics$
	.on(initializeAnalyticsFx.doneData, (_, result) => result);
